/**
 * @name findItemBy
 * @description 계층형(트리형) 데이터에서 특정 키-값 쌍을 가진 항목을 재귀적으로 찾는 함수
 * @param {T | T[]} items - 탐색할 항목(단일 객체 또는 객체 배열)
 * @param {keyof T} key - 찾고자 하는 키
 * @param {any} value - 찾고자 하는 값
 * @returns {T | undefined} - 일치하는 항목을 찾으면 반환, 없으면 undefined
 */
export function findItemBy<T extends Record<string, any>>(
    items: T | T[],
    key: keyof T,
    value: any,
): T | undefined {
    // items가 배열이 아니라면 배열로 감싸기
    const list = Array.isArray(items) ? items : [items];

    for (const item of list) {
        // 현재 객체가 일치하면 반환
        if (item[key] === value) {
            return item;
        }

        // children이 있다면 재귀 탐색
        const children = item["children"];
        if (Array.isArray(children)) {
            const found = findItemBy(children, key, value);
            if (found) return found;
        }
    }

    // 못 찾으면 undefined 반환
    return undefined;
}
